export const pick = (object, ...props) => props.reduce(function(result, prop) {
    result[prop] = object[prop];
    return result;
}, {});

export const pickMap = (object, reducer) => reducer({...object})

export const omit = (object, ...props) => {
    const result = { ...object };
    props.forEach(function(prop) {
      delete result[prop];
    });
    return result;
  }



// WEBPACK FOOTER //
// ./src/utils/JSONObject.js